import { render, staticRenderFns } from "./edit-v2.vue?vue&type=template&id=f73cb132&scoped=true&"
import script from "./edit-v2.vue?vue&type=script&lang=js&"
export * from "./edit-v2.vue?vue&type=script&lang=js&"
import style0 from "./edit-v2.vue?vue&type=style&index=0&id=f73cb132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73cb132",
  null
  
)

export default component.exports